/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import { DatePicker} from 'antd'
import Label from 'components/Form/Label'
import Flex from 'components/Flex'

const StyledDatePicker = styled(DatePicker)`
  border-radius: 10px;
  width: 100%;
  height: 48px;
  border-color: #e9e9e9;
  color: '#010E30';
  font-weight: 500;
  box-shadow: none;
  .ant-picker-focused {
    border-color: #e9e9e9 !important;
    box-shadow: none;
  }

  &:focus {
    color: '#010E30';
    background: #fafafb;
    border-color: #e9e9e9 !important;
    box-shadow: none;
  }
  &:hover {
    border-color: #e9e9e9;
  }
  .ant-picker-input > input {
    font-size: 14px;
    font-weight: 500;
  }
  background-color: ${props =>
    !props?.disabled
      ? !props.defaultValue
        ? '#fafafb'
        : '#ffffff'
      : ''} !important;
`
const LabelWrapper = styled.div`
  margin-top: 2px;
  padding-bottom: 8px;
`
const DatePickerComp = ({
  format = 'DD/MM/YYYY',
  placeholder,
  onChange,
  defaultValue,
  value,
  label,
  width = '100%',
  position = 'relative',
  disabled = false,
  ...rest
}) => {
  return (
    <Flex
      column
      style={{
        width: width,
        position: position,
      }}
      id="select"
    >
      {label && (
        <LabelWrapper>
          <Label labelStyle={labelStyle}>{label}</Label>
        </LabelWrapper>
      )}
      <StyledDatePicker
        disabled={disabled}
        format={format}
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
        value={value}
        getPopupContainer={trigger => trigger.parentNode}
        {...rest}
      />
    </Flex>
  )
}

export default DatePickerComp
